'use strict';

var novicell = novicell || {};

novicell.wizard = novicell.wizard || new function () {
    this.init = function (data) {
        const listWrappers = document.querySelectorAll('.contact-wizard');
        if (!listWrappers) {
            return;
        }
        Vue.directive('init', {
            bind: function (el, binding, vnode) {
                // convert kebab-case to camelCase
                let arg = binding.arg.split('-').map((arg, index) => {
                    return (index > 0) ? arg[0].toUpperCase() + arg.substring(1) : arg;
                }).join('');

                vnode.context[arg] = binding.value;
            }
        });
        for (var i = 0; i < listWrappers.length; i++) {
            let currentList = listWrappers[i];

            new Vue({
                el: currentList,
                name: 'contactWizard',
                data: {
                    wizardData: {},
                    foldOut: false,
                    countryOptions: [],
                    contactsNotAvailable: false,
                    showReadyAnimation: false,
                    regionControlActive: true,
                    chosenOptions: {
                        animalSegment: '',
                        region: '',
                        country: '',
                        employees: []
                    }
                },
                computed: {
                    currentContactStatus: function () {
                        /* statuses are: ['optionsNotSelected','noContactsAvailable','contacsFound'] */
                        let status = 0;
                        if(this.contactsNotAvailable) {
                            status = 1;
                        }else if(this.chosenOptions.employees.length) {
                            status = 2;
                        }

                        return status;
                    },
                    // regionControlActive: function () {
                    //     return this.chosenOptions.animalSegment !== '';
                    // },
                    countryControlActive: function () {
                        return this.chosenOptions.region !== '';
                    }
                    
                    
                },
                methods: {
                    attributePhone: function (phone) {
                        return phone.replace(/\s+/g, '');
                    },
                    attributeEmail: function (email) {
                        return email.replace(/\s+/g, '');
                    },
                    toggleWizard: function () {
                        this.foldOut = !this.foldOut;
                    },
                    setAnimalSegment: function (type) {
                        if(this.chosenOptions.animalSegment === type) {
                            this.chosenOptions.animalSegment = '';
                        }else {
                            this.chosenOptions.animalSegment = type;
                        }
                        this.findContact();
                    },
                    setRegion: function (chosenRegion) {
                        if(chosenRegion.RegionTitle !==this.chosenOptions.region){
                            this.chosenOptions.region = chosenRegion.RegionTitle;
                            this.countryOptions = chosenRegion.Countries;
                            this.chosenOptions.country = '';
                            this.findContact();
                        }
                    },
                    findContact: function () {
                        this.showReadyAnimation = false;
                        if(this.chosenOptions.region !== '' && this.chosenOptions.country !== '') {
                            var possibleEmployees = this.wizardData.Employees.filter((emp)=>{
                                let useEmp = false;
                                const correctCountry = emp.LocationList.includes(this.chosenOptions.country);
                                let correctAnimalSegment = true;
                                if(correctCountry) {
                                    if(this.chosenOptions.animalSegment !== '') {
                                        const checkAnimalSegments = emp.AnimalSegments.filter((seg)=>{
                                            return seg.Name === this.chosenOptions.animalSegment;
                                        });
                                        correctAnimalSegment = checkAnimalSegments.length > 0;
                                    }
                                }
                                return correctCountry && correctAnimalSegment;
                            });


                            if(!possibleEmployees.length){
                                this.resetFoundContact();
                                this.contactsNotAvailable = true;
                            }else{
                                this.chosenOptions.employees = possibleEmployees.slice(0, 3);
                                this.contactsNotAvailable = false;
                                setTimeout(()=> {
                                    this.showReadyAnimation = true; //won't work without delay
                                },100);
                            }
                        }else {
                            this.resetFoundContact();
                            this.contactsNotAvailable = false;
                        }
                        
                    },
                    resetFoundContact() {
                        this.chosenOptions.employees = [];
                    }
                }
            });
        }
    };
}();